import { UIBindings } from '@intelingu/core/components/provider/UIProvider';
import * as React from 'react';
import {ErrorMessage} from "./partials/form/ErrorMessage";

export const bindings: UIBindings = {
    form: {
        form: ({ onSubmit, children }) => {
            return <form onSubmit={e => { e.preventDefault(); onSubmit(); }}>
                {children}
            </form>
        },
        errorMessageBinding: (props) => <ErrorMessage {...props} />
    }
};
